import React from "react";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";
import { displayMessage } from "../../services/helper";

Chart.register(CategoryScale);

export default function ActivePatientsHoursGraph({ activePatientsHourData }) {

    const hours = [];

    if (activePatientsHourData) {
        Object.keys(activePatientsHourData).forEach((key) => {
            hours.push(key + ":00");
        })
    }


    const options = {
        scales: {
            y: {
                ticks: {
                    stepSize: 1
                },
                beginAtZero: true,
                min: 0,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    const labels = hours;

    const data = {
        labels,
        datasets: [
            {
                label: displayMessage('PATIENT_NUMBER'),
                data: Object.values(activePatientsHourData ? activePatientsHourData : 0),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgb(53, 162, 235)',
            },
        ],
    };

    return (
        <>
            <Line data={data} options={options} width={300} height={500} />
        </>
    )
}